import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as companyApi from '../../../api/Company';
import LoadingOverlay from '../../common/LoadingOverlay';
import FormInput from '../../common/form/Input';
import FormPhoneInput from '../../common/form/PhoneInput';
import Form from '../../common/form/Form';
import Button from '../../common/form/Button';
import { formatPhoneNumber } from '../../../utilities/Utils';
import { userIsCompanyAdmin, userIsSystemAdmin } from '../../../utilities/identity';
import '../../../styles/CompanyLevel.css';
import CollapsibleCard from '../../common/CollapsibleCard';
import TabbedPage, { LabeledPage } from '../../common/TabbedPage';
// import { CompanyIntegrations } from '../../../api/Company';

// interface CompanyIntegrations {
//     integrationId: string,
//     key: string
// }
import {userIsCompanyManageUser,userIsPropertyManageUser,userIsSystemManageUser} from '../../../utilities/identity';
import FormSelectLabeled from '../../common/form/SelectLabeled';
import { fetchKeyCafeCompanies } from '../../../api/PropertyIntegration';

interface State {
    smartrent: companyApi.SmartRent;
    id?: number | null;
    name: string;
    companyName: string;
    salesforceClientId: string;
    contactEmail: string;
    contactPhone: string;
    wasFormValidated: boolean;
    errorMessage?: string;
    successMessage?: string;
    isLoading: boolean;
    applicationWidgetStatus:boolean;
    keyCafeGroupId: string;
    companies: any;
}

interface Props extends RouteComponentProps<{}> {
    companyId?: number;
    createUser: () => void;
    createProperty: (companyId: number) => void;
    updateCompanyId: (newCompanyId: number) => void;
    updateTreeview: () => void;
}

class EditCompanyPane extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            wasFormValidated: false,
            smartrent: {
                key: '',
                secret: ''
            },
            id: null,
            name: '',
            companyName: '',
            salesforceClientId: '',
            contactEmail: '',
            contactPhone: '',
            isLoading: false,
            applicationWidgetStatus: false,
            keyCafeGroupId: '',
            companies:  null
        };

        this.getState = this.getState.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.smartRentIdUpdate = this.smartRentIdUpdate.bind(this);
        this.smartRentKeyUpdate = this.smartRentKeyUpdate.bind(this);
        this.fetchCompanies = this.fetchCompanies.bind(this);
    }

    componentDidMount() {
        this.fetchCompanies();
        this.getState();
    }

    async fetchCompanies() {
        try {
          let result = await fetchKeyCafeCompanies()
          if (result.success && result.data) {
            this.setState({ companies: result.data }, () => {
              console.log(this.state.companies, 'companies data');
            });
          }
        } catch (error) {
          console.error('Error fetching tour data:', error);
        }
      }

    componentDidUpdate(prevProps: Props, prevState: State) {
        if (prevProps.companyId !== this.props.companyId) {
            this.getState();
        }
    }

    render() {
        const isUser = (
            userIsCompanyManageUser() ||
            userIsPropertyManageUser() ||
            userIsSystemManageUser()
        );
        let pages: LabeledPage[] = [];

        if (this.state) {
            if(userIsSystemAdmin() || userIsCompanyAdmin()){
                pages = [
                    {
                        tabLabel: 'Basic Info',
                        render: () => (
                            <div>
                                <LoadingOverlay show={this.state.isLoading} inBootstrapColumn={true} />
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col">
                                            {this.props.companyId && (
                                                <div
                                                    className="d-flex justify-content-start btn-group"
                                                    role="group"
                                                >
                                                    { userIsSystemAdmin() && <Button
                                                        text="Add Property"
                                                        onClick={() =>
                                                            this.props.companyId
                                                                ? this.props.createProperty(this.props.companyId)
                                                                : {}  
                                                        }
                                                        addlClassName="btn-primary"
                                                        disabled={isUser}
                                                    />}
                                                    <Button
                                                        text="Add User"
                                                        onClick={this.props.createUser}
                                                        addlClassName="btn-primary"
                                                        disabled={isUser}
                                                    />
                                                </div>
                                            )}
                                           {userIsSystemAdmin() && (<Form
                                                inBootstrapColumn={true}
                                                submitButtonText={
                                                    this.props.companyId ? 'Update Company Info' : 'Create Company'
                                                }
                                                errorMessage={this.state.errorMessage}
                                                successMessage={this.state.successMessage}
                                                onSubmit={this.onSubmit}
                                                wasFormValidated={this.state.wasFormValidated}
                                                onFormValidated={() =>
                                                    this.inputChangeHandler('wasFormValidated', true)
                                                }
                                                disabled={isUser}
                                            >
                                                <div className="card info-card">
                                                    <div className="card-body">
                                                        <FormInput
                                                            inputProps={{
                                                                id: 'company-name',
                                                                name: 'companyName',
                                                                value: this.state.companyName,
                                                                required: true,
                                                                disabled: isUser
                                                            }}
                                                            labelProps={{
                                                                labelText: 'Company Name'
                                                            }}
                                                            onChange={this.inputChangeHandler}
                                                        />
                                                        <FormInput
                                                            inputProps={{
                                                                id: 'contact-email',
                                                                name: 'contactEmail',
                                                                value: this.state.contactEmail,
                                                                type: 'email',
                                                                required: true,
                                                                disabled: isUser
                                                            }}
                                                            labelProps={{
                                                                labelText: 'Contact Email',
                                                                invalidText: 'Please enter a valid email'
                                                            }}
                                                            onChange={this.inputChangeHandler}
                                                        />
                                                        <FormPhoneInput
                                                            inputProps={{
                                                                id: 'contact-phone',
                                                                name: 'contactPhone',
                                                                value: this.state.contactPhone,
                                                                required: true,
                                                                disabled: isUser
                                                            }}
                                                            labelProps={{
                                                                labelText: 'Contact Phone'
                                                            }}
                                                            onChange={this.inputChangeHandler}
                                                        />
                                                        <FormInput
                                                            inputProps={{
                                                                id: 'salesforce-client-id',
                                                                name: 'salesforceClientId',
                                                                value: this.state.salesforceClientId,
                                                                required: false,
                                                                disabled: isUser
                                                            }}
                                                            labelProps={{
                                                                labelText: 'Salesforce Client ID'
                                                            }}
                                                            onChange={this.inputChangeHandler}
                                                        />
                                                    </div>
                                                </div>
                                            </Form>) }
                                            {userIsSystemAdmin() && (
                                                <Button
                                                    text="Delete Company"
                                                    addlClassName="btn-danger"
                                                    disabled={isUser}
                                                    onClick={() => {
                                                        if (
                                                            window.confirm(
                                                                'WARNING: Deleting this company will ' +
                                                                'also delete any associated properties and users. ' +
                                                                'Please confirm that you intend to do this.'
                                                            )
                                                        ) {
                                                            this.handleCompanyDelete();
                                                        }
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    },
                    {
                        tabLabel: 'Advanced Config',
                        render: () => (
                            <div className="company-level-smart-rent-info">
                                {/* <CollapsibleCard
                               cardTitle="Smartrent Access"
                               cardOpen={true}
                               onCardOpenChange={open => 
                                   open ? () => null : null
                               }
                               isCheckbox={false}                    
                           > */}
                                <Form
                                    inBootstrapColumn={true}
                                    submitButtonText={
                                        this.props.companyId ? 'Update Smartrent Access' : 'Create Company'
                                    }
                                    errorMessage={this.state.errorMessage}
                                    successMessage={this.state.successMessage}
                                    onSubmit={this.onSubmit}
                                    wasFormValidated={this.state.wasFormValidated}
                                    onFormValidated={() =>
                                        this.inputChangeHandler('wasFormValidated', true)
                                    }
                                    disabled={isUser}
                                >
                                    <div className="card info-card">
                                        <div className="card-body">
                                            <FormInput
                                                labelProps={{
                                                    labelText: 'Intergration Key'
                                                }}
                                                inputProps={{
                                                    id: 'integration-id',
                                                    name: 'key',
                                                    value: this.state.smartrent.key,
                                                    disabled: isUser
                                                }}
                                                onChange={this.smartRentIdUpdate}
                                            />
        
                                            <FormInput
                                                labelProps={{
                                                    labelText: 'Secret Code'
                                                }}
                                                inputProps={{
                                                    id: 'secret-key',
                                                    name: 'secret',
                                                    type: 'text',
                                                    value: this.state.smartrent.secret,
                                                    disabled: isUser
                                                }}
                                                onChange={this.smartRentKeyUpdate}
                                            />
        
                                            <hr />
                                        </div>
                                    </div>
        
                                </Form>
                               {this.state.companies && <FormSelectLabeled
                                    selectProps={{
                                        id: 'keycafeconfig-group-id',
                                        name: 'keyCafeGroupId',
                                        value: this.state.keyCafeGroupId,
                                        disabled: isUser,
                                    }}
                                    labelProps={{
                                        labelText: 'KeyCafe Configuration'
                                    }}
                                    selectOptions={[
                                        { value: '', label: 'Select a company' }, // Empty option
                                        ...(
                                            this.state.companies === undefined
                                                ? []
                                                : this.state.companies.map((c: any) => ({
                                                    value: c.id,
                                                    label: c.name
                                                }))
                                        )
                                    ]}
                                    onChange={(_name, value: string) =>{
                                        this.setState(
                                            { keyCafeGroupId: value },
                                            () => this.onSubmit()
                                        )
                                    }
                                        
                                    }
                                />}
                                <h4>Analytics Dashboard Configuration</h4>
                                {userIsSystemAdmin() && (
                               <CollapsibleCard
                               cardTitle="Applications Widget Visibility"
                               cardOpen={this.state.applicationWidgetStatus}
                               collapseStyle={{ display: 'none' }}
                               onCardOpenChange={(open) => {
                                   this.setState(
                                       { applicationWidgetStatus: open },
                                       () => this.onSubmit()
                                   );
                               }}
                           >         
                               <></>
                           </CollapsibleCard>
                           
        
                                )}
                                

                            </div>
                        )
                    }
                ];

                if(userIsCompanyAdmin()){
                    pages=[pages[0]]
                }
            }
        }

        return (
            <>
                <TabbedPage pages={pages} onPageChange={() => null} />
            </>
        );
    }

    async getState() {
        if (this.props.companyId) {
            this.setState({
                ...this.state,
                wasFormValidated: false,
                errorMessage: undefined,
                successMessage: undefined,
                isLoading: true
            });
            let companyResult = await companyApi.getCompany(this.props.companyId);
            if (companyResult.success) {
                this.setState({
                    ...this.state,
                    smartrent: {
                        key: companyResult.data!.smartrent ? companyResult.data!.smartrent.key : '',
                        secret: companyResult.data!.smartrent ? companyResult.data!.smartrent.secret : ''
                    },
                    companyName: companyResult.data!.name,
                    contactPhone: formatPhoneNumber(companyResult.data!.contactPhone),
                    contactEmail: companyResult.data!.contactEmail,
                    salesforceClientId: companyResult.data!.salesforceClientId,
                    applicationWidgetStatus: companyResult.data!.applicationWidgetStatus,
                    keyCafeGroupId: companyResult.data!.keyCafeGroupId,
                    isLoading: false
                });
            } else if (companyResult.error !== undefined) {
                this.setState({
                    ...this.state,
                    errorMessage: companyResult.error,
                    isLoading: false
                });
            }
        } else {
            this.setState(
                {
                    ...this.state,
                    smartrent: {
                        key: '',
                        secret: ''
                    },
                    id: null,
                    companyName: '',
                    contactPhone: '',
                    contactEmail: '',
                    keyCafeGroupId: ''
                }

            );
        }
    }

    async handleCompanyDelete() {
        if (this.props.companyId) {
            this.setState({
                ...this.state,
                wasFormValidated: false,
                errorMessage: undefined,
                successMessage: undefined,
                isLoading: true
            });
            let deleteResult = await companyApi.deleteCompany(this.props.companyId);
            if (deleteResult.success) {
                this.setState({
                    ...this.state,
                    successMessage: 'Company deleted',
                    isLoading: false
                });
                location.reload();
            }
        }
    }

    private inputChangeHandler(inputName: string, newValue: string | boolean | number) {
        this.setState(

            {
                ...this.state,
                [inputName]: newValue,
                errorMessage: undefined,
                successMessage: undefined
            }

        );
    }
    private smartRentIdUpdate(inputName: string, newValue: string) {
        this.setState(
            {
                ...this.state,
                smartrent: {
                    key: newValue,
                    secret: this.state.smartrent.secret
                }
            }
        );
    }
    private smartRentKeyUpdate(inputName: string, newValue: string) {
        this.setState(
            {
                ...this.state,
                smartrent: {
                    key: this.state.smartrent.key,
                    secret: newValue
                }
            }
        );
    }

    private onSubmit() {
        this.props.companyId
            ? companyApi
                .updateCompany(this.props.companyId, {
                    name: this.state.companyName,
                    contactPhone: this.state.contactPhone,
                    contactEmail: this.state.contactEmail,
                    smartrent: this.state.smartrent,
                    salesforceClientId: this.state.salesforceClientId,
                    applicationWidgetStatus: this.state.applicationWidgetStatus,
                    keyCafeGroupId: this.state.keyCafeGroupId,
                })
                .then(result => {
                    if (result.success) {
                        this.setState({
                            ...this.state,
                            successMessage: 'Update successful'
                        });
                    } else {
                        this.setState({
                            ...this.state,
                            errorMessage: result.error!
                        });
                    }
                })
            : companyApi
                .createCompany({
                    name: this.state.companyName,
                    contactPhone: this.state.contactPhone,
                    contactEmail: this.state.contactEmail,
                    salesforceClientId: this.state.salesforceClientId,
                    smartrent: this.state.smartrent,
                    applicationWidgetStatus: this.state.applicationWidgetStatus,
                    keyCafeGroupId: this.state.keyCafeGroupId
                })
                .then(result => {
                    if (result.success && result.data) {
                        this.setState({
                            ...this.state,
                            successMessage: 'Company created'
                        });
                        this.props.updateCompanyId(result.data.id);
                        this.props.updateTreeview();
                    } else {
                        this.setState({
                            ...this.state,
                            errorMessage: result.error!
                        });
                    }
                });
    }
    
    //     private smartRentUpdate() {
    //         this.props.companyId
    //             && companyApi
    //                   .updateCompanySmartRent(this.props.companyId, {
    //                       smartrent: this.state.smartrent                   
    //                   })
    //                   .then(result => {
    //                       if (result.success) {
    //                           this.setState({
    //                               ...this.state,
    //                               successMessage: 'Update successful'
    //                           });
    //                       } else {
    //                           this.setState({
    //                               ...this.state,
    //                               errorMessage: result.error!
    //                           });
    //                       }
    //                   })
    //     }
}

export default withRouter<Props>(EditCompanyPane);



// WEBPACK FOOTER //
// ./src/components/pages/admin/EditCompanyPane.tsx